import { memo } from "react";
import { Handle, Position } from "reactflow";
import { Building2, Users, User } from "lucide-react";
import { cn } from "@/lib/utils";
const icons = {
  servant: User,
  institution: Building2,
  department: Users
};
export const CustomNode = memo(({
  data,
  isConnectable
}: {
  data: any;
  isConnectable: boolean;
}) => {
  const Icon = icons[data.type as keyof typeof icons];
  return <div className={cn("rounded-lg border px-4 py-2 shadow-sm", data.type === "person" && "border-blue-500/20 bg-blue-500/10", data.type === "institution" && "border-purple-500/20 bg-purple-500/10", data.type === "department" && "border-orange-500/20 bg-orange-500/10")}>
      <Handle type="target" position={Position.Top} isConnectable={isConnectable} className="!bg-muted-foreground" />
      <div className="flex items-center gap-2">
        <Icon className="h-4 w-4" />
        <span className="text-sm font-medium">{data.label}</span>
      </div>
      <Handle type="source" position={Position.Bottom} isConnectable={isConnectable} className="!bg-muted-foreground" />
    </div>;
});
CustomNode.displayName = "CustomNode";